import React from 'react';
import ReactDOM from 'react-dom';
import Router from './Router';
import './public.css';
import './util/flexible';
import axios from 'axios'; // 引入axios
import './i18n';
import md5 from 'js-md5';
import { delCookie } from './util/cookie';
import {
  keyCodeInit,
  setVChannelId,
  AstroSetCookie,
  setTVKPlatFormInfo,
  setPTInfo,
  focusPlugInit,
  setGuid,
} from './util/util';
import { kernelInit, swInit } from './util/kernalAndSwInit';
setGuid();
// 初始化kernel包
kernelInit();
// 初始化server worker
swInit();
// 将md5加密方法挂载到React组件原型上，目前只在helpFeedback页面中使用了这个方法
React.Component.prototype.$md5 = md5;
// 删除LG侧筛选页存储的聚焦元素
// 这个筛选页面目前没有使用路由缓存的形式，看之后可不可以切换为路由缓存
// 目前是出页面需要保存当前聚焦状态会将聚焦元素存在本地，然后返回时再取出使用
// 这个主要是目前点击home键退出应用并没有处理，消除该种情况下从主页进筛选页跳到对应聚焦位置的影响
delCookie('filterPageLG_current_focus');
// 清空之前的主页缓存数据
localStorage.removeItem('allInterfaceDataCache');

axios.defaults.withCredentials = true;
// 设置渠道渠道Id(该方法中带修正逻辑)
setVChannelId();
// 键码值初始化(上下左右点击事件绑定对应键码值)
keyCodeInit();
// 针对cookie信息在退出应用后不保存的设备添加该处理
// 将localstorage中的cookie信息取出存入cookie
AstroSetCookie();
const plat = document.domain === 'tv.iflix.com' || document.domain === 'test.iflix.com' ? 'iflix' : 'wetv';
setPTInfo(plat);
setTVKPlatFormInfo(plat);
// 初始化react-tv-focusable依赖包
focusPlugInit();
// 挂载页面
ReactDOM.render(<Router />, document.getElementById('root'), async () => {
  const { appLaunchReport, initCookieValue, defaultSetting } = await import('./util/appLaunch');
  // 初始化cookie值，如果没有guid等信息，则补充这些信息
  initCookieValue();
  // 应用启动上报
  appLaunchReport();
  defaultSetting();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
